// ------- Phone-Icon ------- //
export const PhoneIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1902_49059)">
        <path
          d="M14.7162 10.5022C13.7366 10.5022 12.7747 10.349 11.8633 10.0478C11.4167 9.89542 10.8676 10.0352 10.595 10.3151L8.796 11.6732C6.70963 10.5595 5.42446 9.27475 4.32596 7.20404L5.64408 5.45188C5.98654 5.10988 6.10938 4.61029 5.96221 4.14154C5.65971 3.22529 5.50604 2.26392 5.50604 1.28392C5.50608 0.575958 4.93013 0 4.22221 0H1.28387C0.575958 0 0 0.575958 0 1.28387C0 9.39846 6.60158 16 14.7162 16C15.4241 16 16 15.424 16 14.7161V11.786C16 11.0781 15.424 10.5022 14.7162 10.5022Z"
          fill="#00968F"
        />
      </g>
      <defs>
        <clipPath id="clip0_1902_49059">
          <rect width="16" height="16" fill="#00968F" />
        </clipPath>
      </defs>
    </svg>
  );
};

// ------- Email-Icon ------- //
export const EmailIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8591 3.17878L11.0066 8L15.8591 12.8212C15.9468 12.6379 16 12.4352 16 12.2188V3.78125C16 3.56478 15.9468 3.36213 15.8591 3.17878ZM14.5938 2.375H1.40625C1.18978 2.375 0.987125 2.42822 0.803781 2.51594L7.00575 8.68666C7.55413 9.23503 8.44588 9.23503 8.99425 8.68666L15.1962 2.51594C15.0129 2.42822 14.8102 2.375 14.5938 2.375ZM0.140938 3.17878C0.0532188 3.36213 0 3.56478 0 3.78125V12.2188C0 12.4352 0.0532188 12.6379 0.140938 12.8212L4.99341 8L0.140938 3.17878Z"
        fill="#00968F"
      />
      <path
        d="M10.3437 8.66309L9.65702 9.34974C8.7433 10.2635 7.25652 10.2635 6.3428 9.34974L5.65618 8.66309L0.803711 13.4843C0.987055 13.572 1.18971 13.6252 1.40618 13.6252H14.5937C14.8101 13.6252 15.0128 13.572 15.1961 13.4843L10.3437 8.66309Z"
        fill="#00968F"
      />
    </svg>
  );
};

// ------- Location-Icon ------- //
export const LocationIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99967 0C4.80452 0 2.20508 2.59944 2.20508 5.79456C2.20508 9.75981 7.39067 15.581 7.61145 15.8269C7.81883 16.0579 8.18089 16.0575 8.38789 15.8269C8.60867 15.581 13.7943 9.75981 13.7943 5.79456C13.7942 2.59944 11.1948 0 7.99967 0ZM7.99967 8.70997C6.39211 8.70997 5.0843 7.40212 5.0843 5.79456C5.0843 4.187 6.39214 2.87919 7.99967 2.87919C9.6072 2.87919 10.915 4.18703 10.915 5.79459C10.915 7.40216 9.6072 8.70997 7.99967 8.70997Z"
        fill="#00968F"
      />
    </svg>
  );
};

// ------- Twitter-Icon ------- //

export const TwitterIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5554_57785)">
        <path
          d="M8.30314 5.92804L13.4029 0H12.1944L7.7663 5.14724L4.22958 0H0.150391L5.4986 7.78354L0.150391 14H1.35894L6.03514 8.56434L9.77017 14H13.8494L8.30284 5.92804H8.30314ZM6.64787 7.85211L6.10598 7.07705L1.79439 0.909771H3.65065L7.13015 5.88696L7.67204 6.66202L12.195 13.1316H10.3387L6.64787 7.85241V7.85211Z"
          fill="#222222"
        />
      </g>
      <defs>
        <clipPath id="clip0_5554_57785">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// ------- Whatsapp-Icon ------- //
export const WhatsappIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00175 0H6.99825C3.13863 0 0 3.1395 0 7C0 8.53125 0.4935 9.9505 1.33263 11.1029L0.46025 13.7034L3.15088 12.8433C4.25775 13.5765 5.57812 14 7.00175 14C10.8614 14 14 10.8596 14 7C14 3.14038 10.8614 0 7.00175 0ZM11.0749 9.88488C10.906 10.3617 10.2358 10.7572 9.70113 10.8727C9.33537 10.9506 8.85763 11.0128 7.24937 10.346C5.19225 9.49375 3.8675 7.40337 3.76425 7.26775C3.66537 7.13212 2.933 6.16088 2.933 5.15637C2.933 4.15188 3.44313 3.66275 3.64875 3.45275C3.81763 3.28038 4.09675 3.20162 4.3645 3.20162C4.45113 3.20162 4.529 3.206 4.599 3.2095C4.80463 3.21825 4.90788 3.2305 5.0435 3.55513C5.21238 3.962 5.62362 4.9665 5.67262 5.06975C5.7225 5.173 5.77238 5.313 5.70238 5.44863C5.63675 5.58863 5.579 5.65075 5.47575 5.76975C5.3725 5.88875 5.2745 5.97975 5.17125 6.1075C5.07675 6.21863 4.97 6.33763 5.089 6.54325C5.208 6.7445 5.61925 7.41562 6.22475 7.95462C7.00612 8.65025 7.63962 8.8725 7.86625 8.967C8.03512 9.037 8.23637 9.02038 8.35975 8.88913C8.51637 8.72025 8.70975 8.44025 8.90662 8.16463C9.04663 7.96688 9.22338 7.94237 9.40888 8.01237C9.59788 8.078 10.598 8.57237 10.8036 8.67475C11.0092 8.778 11.1449 8.827 11.1947 8.91363C11.2437 9.00025 11.2437 9.40712 11.0749 9.88488Z"
        fill="#222222"
      />
    </svg>
  );
};

// ------- Instagram-Icon ------- //
export const InstagramIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5554_49840)">
        <path
          d="M8.23047 7C8.23047 7.67955 7.67955 8.23047 7 8.23047C6.32045 8.23047 5.76953 7.67955 5.76953 7C5.76953 6.32045 6.32045 5.76953 7 5.76953C7.67955 5.76953 8.23047 6.32045 8.23047 7Z"
          fill="#222222"
        />
        <path
          d="M9.07812 3.28125H4.92188C4.01718 3.28125 3.28125 4.01718 3.28125 4.92188V9.07812C3.28125 9.98282 4.01718 10.7188 4.92188 10.7188H9.07812C9.98282 10.7188 10.7188 9.98282 10.7188 9.07812V4.92188C10.7188 4.01718 9.98282 3.28125 9.07812 3.28125ZM7 9.05078C5.8692 9.05078 4.94922 8.1308 4.94922 7C4.94922 5.8692 5.8692 4.94922 7 4.94922C8.1308 4.94922 9.05078 5.8692 9.05078 7C9.05078 8.1308 8.1308 9.05078 7 9.05078ZM9.35156 5.05859C9.12502 5.05859 8.94141 4.87498 8.94141 4.64844C8.94141 4.42189 9.12502 4.23828 9.35156 4.23828C9.57811 4.23828 9.76172 4.42189 9.76172 4.64844C9.76172 4.87498 9.57811 5.05859 9.35156 5.05859Z"
          fill="#222222"
        />
        <path
          d="M10.3086 0H3.69141C1.65599 0 0 1.65602 0 3.69141V10.3086C0 12.344 1.65602 14 3.69141 14H10.3086C12.344 14 14 12.344 14 10.3086V3.69141C14 1.65599 12.344 0 10.3086 0ZM11.5391 9.07812C11.5391 10.4351 10.4351 11.5391 9.07812 11.5391H4.92188C3.56494 11.5391 2.46094 10.4351 2.46094 9.07812V4.92188C2.46094 3.56494 3.56494 2.46094 4.92188 2.46094H9.07812C10.4351 2.46094 11.5391 3.56494 11.5391 4.92188V9.07812Z"
          fill="#222222"
        />
      </g>
      <defs>
        <clipPath id="clip0_5554_49840">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// ------- Facebook-Icon ------- //
export const FacebookIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5554_49848)">
        <path
          d="M8.08433 14V7.61441H10.2268L10.5483 5.12509H8.08433V3.53603C8.08433 2.81554 8.28358 2.32454 9.31793 2.32454L10.635 2.32399V0.097461C10.4072 0.0678617 9.62539 0 8.71539 0C6.81517 0 5.51425 1.15988 5.51425 3.28949V5.12509H3.36523V7.61441H5.51425V14H8.08433Z"
          fill="#222222"
        />
      </g>
      <defs>
        <clipPath id="clip0_5554_49848">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// ------- Youtube-Icon ------- //
export const YoutubeIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5554_49854)">
        <path
          d="M13.8546 3.43795C13.7033 2.87566 13.26 2.43243 12.6978 2.28102C11.6707 2 7.56233 2 7.56233 2C7.56233 2 3.45413 2 2.42706 2.27037C1.87566 2.42162 1.42154 2.87577 1.27029 3.43795C1 4.46494 1 6.59481 1 6.59481C1 6.59481 1 8.7354 1.27029 9.75164C1.42168 10.3138 1.86485 10.7571 2.42714 10.9085C3.46494 11.1896 7.5625 11.1896 7.5625 11.1896C7.5625 11.1896 11.6707 11.1896 12.6978 10.9192C13.2601 10.7679 13.7033 10.3246 13.8547 9.76245C14.1249 8.73538 14.1249 6.6056 14.1249 6.6056C14.1249 6.6056 14.1357 4.46491 13.8546 3.43795ZM6.2543 8.56244V4.62713L9.67062 6.59477L6.2543 8.56244Z"
          fill="#222222"
        />
      </g>
      <defs>
        <clipPath id="clip0_5554_49854">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// ------- Pintrest-Icon ------- //
export const PintrestIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5554_49860)">
        <path
          d="M7.19014 0C3.35309 0 1.3125 2.45886 1.3125 5.13998C1.3125 6.38341 2.00728 7.93398 3.11946 8.42575C3.28834 8.50188 3.38022 8.46951 3.41784 8.31287C3.4511 8.19387 3.59723 7.62072 3.66811 7.35033C3.68998 7.2637 3.67861 7.18845 3.6086 7.10707C3.23934 6.68005 2.9462 5.90214 2.9462 5.17236C2.9462 3.3024 4.43289 1.48669 6.96263 1.48669C9.15023 1.48669 10.6807 2.90776 10.6807 4.94047C10.6807 7.23745 9.46524 8.82652 7.8858 8.82652C7.01163 8.82652 6.3606 8.14049 6.56711 7.2917C6.8165 6.28103 7.30564 5.19423 7.30564 4.46533C7.30564 3.81167 6.93638 3.2709 6.18209 3.2709C5.29218 3.2709 4.57027 4.15206 4.57027 5.33511C4.57027 6.08677 4.83628 6.5943 4.83628 6.5943C4.83628 6.5943 3.95599 10.1505 3.79236 10.8146C3.51585 11.939 3.82999 13.76 3.85711 13.9166C3.87374 14.0033 3.97087 14.0304 4.02512 13.9595C4.11175 13.8457 5.1758 12.3276 5.47419 11.2303C5.58269 10.8304 6.02809 9.20891 6.02809 9.20891C6.32123 9.73831 7.16739 10.182 8.06868 10.182C10.7498 10.182 12.6871 7.82548 12.6871 4.9011C12.6775 2.09747 10.2782 0 7.19014 0Z"
          fill="#222222"
        />
      </g>
      <defs>
        <clipPath id="clip0_5554_49860">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
